<template>
  <div id = "home">
    <!-- Top banner -->
    <section>
      <banner
        :lift = "topBanner"
        :aspectRatio = "topBannerAspectRatio"
        sizes = "(max-width: 480px) 300px, 600px"
        textRight
      />
    </section>

    <!-- Customer promises -->
    <section v-if = "!$vuetify.breakpoint.xsOnly">
      <slogans/>
    </section>

    <base-container>
      <!-- Categories -->
      <section>
        <Categories :categories="categories"/>
      </section>

      <!-- ArtStyle -->
      <section
        v-if = "styles && styles.length && $vuetify.breakpoint.xsOnly"
        class = "py-3"
      >
        <art-styles :styles = "styles"/>
      </section>

      <!-- Customer promises -->
      <section v-if = "$vuetify.breakpoint.xsOnly">
        <slogans/>
      </section>

      <!-- ArtStyle -->
      <section
        v-if = "styles && styles.length && !$vuetify.breakpoint.xsOnly"
        class = "pt-5 mt-2"
      >
        <art-styles :styles = "styles"/>
      </section>

      <!-- latest artwroks -->
      <section class = "py-5 mt-2">
        <latest/>
      </section>

      <!-- most view artwroks -->
      <section>
        <most-viewed/>
      </section>
    </base-container>

    <!-- Middle banner -->
    <section class = "py-2">
      <column-banner :lift = "middleBanner"/>
    </section>

    <!--- Sold Section -->
    <base-container class = "mt-4">
      <section>
        <sold/>
      </section>
    </base-container>


    <!-- artzie -->
    <section class = "py-5">
      <ArtzieBox/>
    </section>

    <!-- Bottom banner -->
    <section class = "py-5">
      <banner
        :lift = "bottomBanner"
        :aspectRatio = "topBannerAspectRatio"
        sizes = "(max-width: 480px) 300px, 600px"
      />
    </section>

    <!-- Description -->
    <base-container>
      <section>
        <section-heading :text = "$t('HOME.DESCRIPTION_TITLE')"/>

        <v-container
          fluid
          px-0
          ma-0
          grid-list-xxl
        >
          <v-layout
            row
            wrap
          >
            <v-flex
              sm12
              md6
            >
              <v-img
                contain
                width = "100%"
                src = "/static/img/frontpage-pia-patrik.jpg"
              />
            </v-flex>
            <v-flex
              sm12
              md6
            >
              <base-description>
                <p v-t = "'HOME.DESCRIPTION[0]'"></p>
                <p v-t = "'HOME.DESCRIPTION[1]'"></p>
                <p v-t = "'HOME.DESCRIPTION[2]'"></p>
                <p v-t = "'HOME.DESCRIPTION[3]'"></p>
              </base-description>
              <tk-btn
                dark
                color = "black"
                class = "read-story"
                large
                to = "/company"
              >
                <span class = "caption font-weight-medium">
                  {{
                    $t("COMMON.READ_STORY")
                  }}
                </span>
              </tk-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
    </base-container>
  </div>
</template>

<script>
import {ErrorHandler}       from "@/utils/ErrorHandler"
import {categories}         from "../../config"
import BaseTitle            from "@/components/base/BaseTitle"
import BaseDescription      from "@/components/base/BaseDescription"
import Banner               from "./Banner"
import MiddleBanner         from "./MiddleBanner"
import Slogans              from "./Slogans"
import Sold                 from "./Sold"
import ImageCard            from "./ImageCard"
import ArtzieBox            from "@/components/Domain/Artzie/ArtzieBox.vue"
import ArtStyles            from "./ArtStyles"
import Latest               from "./Latest"
import SectionHeading       from "./SectionHeading.vue"
import MostViewed           from "./MostViewed.vue"
import ColumnBanner         from "./ColumnBanner.vue"
import ImageCardRedesigned  from "@/views/Home/ImageCardRedesigned.vue"
import {usePreferenceStore} from "@/components/Domain/Reference/usePreferenceStore"
import Categories from '../../components/Domain/Category/Categories.vue'

const handler = new ErrorHandler()

export default {
  name: "home",
  components: {
    Categories,
    ImageCardRedesigned,
    ArtzieBox,
    BaseDescription,
    BaseTitle,
    MiddleBanner,
    Banner,
    Slogans,
    Sold,
    ImageCard,
    ArtStyles,
    Latest,
    SectionHeading,
    MostViewed,
    ColumnBanner,
  },

  data() {
    return {
      categories: [],
      topBanner: {mobile_media: {}, desktop_media: {}},
      middleBanner: {mobile_media: {}, desktop_media: {}},
      bottomBanner: {mobile_media: {}, desktop_media: {}},
      styles: [],
    }
  },

  computed: {
    currentUser() {
      return this.$auth
    },
    topBannerAspectRatio() {
      if (this.isMobile) return 0.93
      return 2.5
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      await handler.handle(async () => {
        // TODO create separate repository class
        const {fetchItems, findLift, getCategories} = usePreferenceStore()
        const {lifts} = await fetchItems()

        this.topBanner = findLift({position: "top-wide-100%"}) || {}
        this.middleBanner = findLift({position: "middle-wide-100%"}) || {}
        this.bottomBanner = findLift({position: "bottom-wide-100%"}) || {}

        this.categories = getCategories()

        this.styles = lifts.filter((l) => l.position === "style")
      })
    },
  },
}
</script>

<style lang = "scss">
.shortcut {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
</style>
